module.exports = __webpack_public_path__ + "img/image03.c6c1e35c.jpg";